export default __webpack_public_path__ + "static/media/circle-x.26f107d5.svg";